import axios from 'axios';
import qs from 'qs';


export default () => {
    console.log('load more');
    const button = document.getElementById('more-button');
    const cardsGrid = document.getElementById('page-grid');
    if (!button) return;
    const buttonText = button.innerText;
    const params = window.loadmore_params;
    const URL = params.ajaxurl;
    const query = params.posts;
    const page = params.current_page;
    const maxPage = params.max_page;
    const templatePartIndicator = params.template_part_indicator;
    const data = {action: 'loadmore', query, page, templatePartIndicator};
    let isStatusLoading = false;

    const removeButton = () => {
        button.remove();
    };

    const setStatus = isLoading => {
        if (isLoading) {
            isStatusLoading = true;
            button.innerText = 'Loading...';
        } else {
            isStatusLoading = false;
            button.innerText = buttonText;
        }
    };

    const insertPost = posts => {
        cardsGrid.insertAdjacentHTML('beforeend', posts);
    };

    if (page === maxPage) removeButton();

    const handleClick = e => {
        e.preventDefault();
        console.log(params);
        if (isStatusLoading) return;
        setStatus(true);
        axios({
            method: 'post',
            url: URL,
            data: qs.stringify(data),
        }).then(response => {
            console.log('response.data');
            console.log(response.data);
            const posts = response.data;
            if (posts) {
                console.log('insert posts');
                insertPost(posts);
                data.page++;
                if (data.page === maxPage) {
                    console.log('remove btn');
                    removeButton();
                } else {
                    console.log('set status false');
                    setStatus(false);
                }
            } else {
                console.log('remove btn 2');
                removeButton();
            }
        }).catch(() => {
            console.log('remove btn 3');
            removeButton();
        });
    };

    button.addEventListener('click', handleClick);
}